import { jsx as _jsx } from "react/jsx-runtime";
export const SaoPauloIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.97834 1.5H6.06195L6.08649 1.58081L1 18.4028L1.34126 18.5L6.27221 2.19235L6.45439 2.7922L2.20973 18.4075L2.55361 18.4955L6.64847 3.43128L6.96663 4.47888L3.41968 18.4097L3.76494 18.4925L7.1659 5.13503L7.50087 6.23799L4.63028 18.4126L4.97697 18.4896L7.70625 6.91425L7.98712 7.83908L8.06246 8.05185L5.68776 18.4802H7.54964L9.70864 8.99816L11.8676 18.4802H13.729L11.3549 8.05106L11.43 7.83909L11.7178 6.89149L14.4037 18.4893L14.7507 18.4136L11.9247 6.21063L12.2496 5.14105L15.6151 18.4927L15.9605 18.4107L12.4497 4.48237L12.7496 3.49509L16.8266 18.4958L17.1705 18.4078L12.9437 2.85606L13.1416 2.20449L18.0388 18.5L18.3802 18.4034L13.3279 1.59146L13.3557 1.5H11.4388L10.9049 3.26119H8.51203L7.97834 1.5ZM10.27 5.35592H9.14679L9.70832 7.20899L10.27 5.35592Z",
            fill: "#7E3B8A"
        })
    });
